/* Publish by EComposer at 2026-10-01 17:36:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w4qcebdmg0c"]=  window.__ectimmers["ecom-w4qcebdmg0c"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-w4qcebdmg0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w4qcebdmg0c', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9irnhusl9ea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9irnhusl9ea', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-os81vf9dznd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-os81vf9dznd', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mlosxsl9zs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mlosxsl9zs', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txvorv1swtg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txvorv1swtg', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1bhi64urrge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1bhi64urrge', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wj0rmevg47h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wj0rmevg47h', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}